import { Report } from './types'

export const cashFlowRecurseExplainer = (cashFlowStatement?: any, payload?: any) => {
  function recurse(cashFlowReportStatementRows: Report) {
    const finalReport = []
    for (const child of cashFlowReportStatementRows) {
      if (child.id === payload.keyFigure.id) {
        child.children = payload.explainer
      } else if (child.children) {
        recurse(child.children)
      }

      finalReport.push(child)
    }

    return finalReport
  }

  return cashFlowStatement && recurse(cashFlowStatement)
}
